import { LIST_CATEGORY, LIST_CATEGORY_FAIL, GET_CATEGORY, DELETE_CATEGORY } from '../actions/types'

const initialState = {
  list: null,
  details: null,
  delete: null,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case LIST_CATEGORY:
      return {
        ...state,
        list: payload,
      }
    case LIST_CATEGORY_FAIL:
      return {
        ...state,
        list: null,
      }
    case GET_CATEGORY:
      return {
        ...state,
        details: payload,
      }
    case DELETE_CATEGORY:
      return {
        ...state,
        delete: payload,
      }
    default:
      return state
  }
}
